import { createStore } from 'vuex'

export default createStore({
  state: {
    isLoggedIn: false,
    userDetails: null,

    isSideNavOpen: true,

    role: null,

    user: null,

    activity: null,

    roleActivity: null,

    workLog: null
  },
  getters: {
    getWorkLog: (state) => state.workLog,

    getRoleActivity: (state) => state.roleActivity,

    getActivity: (state) => state.activity,

    getUser: (state) => state.user,

    getRole: (state) => state.role,

    getIsLoggedIn: (state) => state.isLoggedIn,
    getUserDetails: (state) => state.userDetails,

    getIsSideNavOpen: (state) => state.isSideNavOpen
  },
  mutations: {
    setWorkLog(state, value) {
      state.workLog = value
    },

    setRoleActivity(state, value) {
      state.roleActivity = value
    },

    setActivity(state, value) {
      state.activity = value
    },

    setUser(state, value) {
      state.user = value
    },

    setRole(state, value) {
      state.role = value
    },

    setUserDetails(state, value) {
      state.userDetails = value
    },

    setIsLoggedIn(state, value) {
      state.isLoggedIn = value
    },

    setIsSideNavOpen(state, value) {
      state.isSideNavOpen = value
    }
  },
  actions: {
  },
  modules: {
  }
})
